import React, { useEffect, useState } from "react";
import { getLostDeals } from "../api";
import DealTable from "../components/DealTable";
import "./ActiveDeals.css";

export default function LostDeals() {

const [deals,setDeals]=useState([]);
const [loading,setLoading]=useState(true);

useEffect(()=>{
loadDeals();
},[]);

async function loadDeals(){

try{

const res=await getLostDeals();

setDeals(res.data.data);

}catch(err){

console.log(err);

}

finally{

setLoading(false);

}

}

if(loading){

return <h2 style={{padding:30}}>Loading...</h2>;

}

return(

<div className="active-page">

<div className="page-header">

<div className="page-title">

❌ Lost Deals

</div>

</div>

<DealTable deals={deals}/>

</div>

);

}